<template>
    <b-carousel id="logo-carousel" v-model="slide" :interval="2500" indicators>
        <b-carousel-slide
            v-for="(image, index) in images"
            :key="index"
            :img-src="image"
        />
    </b-carousel>
</template>

<script>
const images = [
    require("@/assets/images/logo-ceran.png"),
    require("@/assets/images/logo-enercan.png"),
    require("@/assets/images/logo-foz-chapeco.png"),
    require("@/assets/images/logo-cpfl-geracao.png"),
    require("@/assets/images/logo-simworx.png"),
    require("@/assets/images/logo-aneel.png")
];

export default {
    name: "LogoCarousel",
    data() {
        return {
            slide: 0
        };
    },
    beforeMount() {
        this.images = images;
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .carousel-item {
        height: 250px;

        > img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .carousel-indicators {
        bottom: -15px;
        li {
            background-color: #b4b4b4;
        }
    }
}
</style>
